/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { absDependencies } from './dependenciesAbs.generated';
import { addDependencies } from './dependenciesAdd.generated';
import { identityDependencies } from './dependenciesIdentity.generated';
import { invDependencies } from './dependenciesInv.generated';
import { maxDependencies } from './dependenciesMax.generated';
import { multiplyDependencies } from './dependenciesMultiply.generated';
import { sizeDependencies } from './dependenciesSize.generated';
import { sqrtDependencies } from './dependenciesSqrt.generated';
import { subtractDependencies } from './dependenciesSubtract.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createSqrtm } from '../../factoriesAny.js';
export var sqrtmDependencies = {
  absDependencies: absDependencies,
  addDependencies: addDependencies,
  identityDependencies: identityDependencies,
  invDependencies: invDependencies,
  maxDependencies: maxDependencies,
  multiplyDependencies: multiplyDependencies,
  sizeDependencies: sizeDependencies,
  sqrtDependencies: sqrtDependencies,
  subtractDependencies: subtractDependencies,
  typedDependencies: typedDependencies,
  createSqrtm: createSqrtm
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesSqrtm.generated.js
// module id = 1521
// module chunks = 0